import React from 'react';

import { Grid, Typography } from '@mui/material';
import { COLOR_PRIMARY_1 } from 'src/colors';

const SubsectionHeading = ({ title, sourceTag }: { title: string; sourceTag?: string }) => (
  <Grid container item xs={12} direction="row" justifyContent="space-between">
    <Typography variant="h2" sx={{ color: COLOR_PRIMARY_1, fontWeight: 400 }}>
      {title}
    </Typography>
    {sourceTag && (
      <Typography
        variant="caption"
        sx={{ color: COLOR_PRIMARY_1, fontWeight: 400, fontStyle: 'italic' }}
      >
        *{sourceTag}
      </Typography>
    )}
  </Grid>
);

export default SubsectionHeading;
